var mandantModule = angular.module('t2g.mandantModule', [
  require('settings').name,
  require('./navigationSettings').name,
  require('./templatePlaceholderService').name,
]);

module.exports = mandantModule;
